module.exports = __webpack_public_path__ + "img/56.487ba079.jpg";